/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Recentthreads1Inputs */

const zh_sidebar_recentthreads1 = /** @type {(inputs: Sidebar_Recentthreads1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近对话`)
};

const en_sidebar_recentthreads1 = /** @type {(inputs: Sidebar_Recentthreads1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent Conversations`)
};

const es_sidebar_recentthreads1 = /** @type {(inputs: Sidebar_Recentthreads1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversaciones recientes`)
};

/**
* | output |
* | --- |
* | "Recent Conversations" |
*
* @param {Sidebar_Recentthreads1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const sidebar_recentthreads1 = /** @type {((inputs?: Sidebar_Recentthreads1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Recentthreads1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_recentthreads1(inputs)
	if (locale === "en") return en_sidebar_recentthreads1(inputs)
	return es_sidebar_recentthreads1(inputs)
});
export { sidebar_recentthreads1 as "sidebar_recentThreads" }